export const services = [
  { icon:'📱', title:'Mobile App Development',  desc:'High-performance iOS & Android apps that are fast, beautiful, and built to scale with your business.',          tag:'iOS · Android · React Native' },
  { icon:'💻', title:'Web App Development',      desc:'From simple pages to complex platforms — secure, scalable web apps that drive real business results.',          tag:'React · Next.js · Node.js'    },
  { icon:'🎨', title:'UI/UX Design',             desc:'Intuitive, beautiful interfaces that users love and that convert visitors into customers.',                     tag:'Figma · Design Systems'       },
  { icon:'🛒', title:'E-Commerce Solutions',     desc:'Beautiful storefronts, seamless checkout, smart integrations — everything to sell online with confidence.',    tag:'WooCommerce · Custom'         },
  { icon:'☁️', title:'Cloud & DevOps',           desc:'Scalable infrastructure, automated deployments and smooth CI/CD pipelines so your app never sleeps.',         tag:'AWS · DigitalOcean · Docker'  },
  { icon:'🔧', title:'Support & Maintenance',    desc:"We don't disappear after launch. We monitor, improve, and keep your product running flawlessly.",              tag:'24/7 · SLA · Monitoring'      },
];

export const team = [
  { initials:'YM', name:'Yosry Mlika',                role:'CEO · Founder', bio:'Full-Stack Developer with 8+ years building scalable products. Drives strategy and loves turning complex ideas into clean code.'         },
  { initials:'MM', name:'Mohamed Moetez Abdelhamid',  role:'CTO',           bio:'Technical architect and engineering lead. Makes sure everything is built right — scalable, secure, and well-tested.'                      },
  { initials:'HJ', name:'Hamza Ben Jannet',            role:'COO',           bio:"Operations expert ensuring every project runs on time and within budget. Bridges your goals with our execution."                          },
];

export const clients = ['Ben Njima','Edidact','Fun Comp','Mbakop','Predict Analyse','Visacom','IMaxeam','Songocom' , 'Fryends' , 'Castypes' ];

export const marqueeWords = ['Mobile Development','Web Applications','UI/UX Design','Cloud & DevOps','E-Commerce','Digital Transformation','React.js','Node.js','MongoDB','AWS'];

export const heroStats = [
  { value:'8+',  label:'Years Experience'  },
  { value:'50+', label:'Projects Shipped'  },
  { value:'15+', label:'Happy Clients'     },
  { value:'3',   label:'Languages Spoken'  },
];

export const aboutStats = [
  { value:'8+',  label:'Years of craft'   },
  { value:'50+', label:'Projects shipped' },
  { value:'15+', label:'Happy clients'    },
  { value:'3',   label:'Languages'        },
];

export const contact = {
  phone:    '+971 52 337 4397',
  email:    'info@nextitera.com',
  location: 'Dubai, UAE — Working Globally',
};
